import { render, staticRenderFns } from "./InputMerkBarang.vue?vue&type=template&id=23a407dd&"
import script from "./InputMerkBarang.vue?vue&type=script&lang=js&"
export * from "./InputMerkBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports